import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { useLocales } from '../hooks/useLocales';
import { DEFAULT_LOCALE } from '../locales-config';

export function IntlProvider({ children }: { children: React.ReactNode }) {
  const { locale, messages } = useLocales();

  return (
    <ReactIntlProvider defaultLocale={DEFAULT_LOCALE} locale={locale} messages={messages}>
      {children}
    </ReactIntlProvider>
  );
}
